module.exports = __webpack_public_path__ + "static/media/questions.4e5a0b3a.svg";